import * as React from "react";
import styled, { css } from "styled-components";
import Field from "views/components/Field";
import FieldTypeIcon from "./FieldTypeIcon";
const StyledListItem = styled.li(
  ({ theme }) => css`
    font-size: ${theme.fonts.size.body};
    display: table-row;
    white-space: nowrap;
  `
);
const ListItem = ({ activeQueryFields, fieldType, selectedQuery, style }) => {
  const { name, type } = fieldType;
  const disabled = !activeQueryFields.find((f) => f.name === name);
  return /* @__PURE__ */ React.createElement(StyledListItem, { style }, /* @__PURE__ */ React.createElement(FieldTypeIcon, { type }), " ", /* @__PURE__ */ React.createElement(Field, { queryId: selectedQuery, disabled, name, type }, name));
};
export default ListItem;
